import { render, staticRenderFns } from "./StatusProfileAdminControl.vue?vue&type=template&id=119323c8&"
import script from "./StatusProfileAdminControl.vue?vue&type=script&lang=ts&"
export * from "./StatusProfileAdminControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports